/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { DayOfWeek } from './DayOfWeek';
import {
    DayOfWeekFromJSON,
    DayOfWeekFromJSONTyped,
    DayOfWeekToJSON,
} from './DayOfWeek';
import type { JobScheduleDtoFrequency } from './JobScheduleDtoFrequency';
import {
    JobScheduleDtoFrequencyFromJSON,
    JobScheduleDtoFrequencyFromJSONTyped,
    JobScheduleDtoFrequencyToJSON,
} from './JobScheduleDtoFrequency';

/**
 * 
 * @export
 * @interface JobScheduleDto
 */
export interface JobScheduleDto {
    /**
     * 
     * @type {string}
     * @memberof JobScheduleDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof JobScheduleDto
     */
    periodStart: string;
    /**
     * 
     * @type {string}
     * @memberof JobScheduleDto
     */
    periodEnd: string;
    /**
     * 
     * @type {string}
     * @memberof JobScheduleDto
     */
    executionStart: string;
    /**
     * 
     * @type {string}
     * @memberof JobScheduleDto
     */
    executionEnd: string;
    /**
     * 
     * @type {boolean}
     * @memberof JobScheduleDto
     */
    executionAllDay?: boolean;
    /**
     * 
     * @type {JobScheduleDtoFrequency}
     * @memberof JobScheduleDto
     */
    frequency: JobScheduleDtoFrequency | null;
    /**
     * 
     * @type {number}
     * @memberof JobScheduleDto
     */
    interval?: number;
    /**
     * 
     * @type {Array<DayOfWeek>}
     * @memberof JobScheduleDto
     */
    weekdays?: Array<DayOfWeek> | null;
    /**
     * 
     * @type {string}
     * @memberof JobScheduleDto
     */
    timeZone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobScheduleDto
     */
    $type?: JobScheduleDtoTypeEnum;
}


/**
 * @export
 */
export const JobScheduleDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobConfigurationComponentDtoJobScheduleDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobConfigurationComponent.Dto.JobScheduleDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type JobScheduleDtoTypeEnum = typeof JobScheduleDtoTypeEnum[keyof typeof JobScheduleDtoTypeEnum];


/**
 * Check if a given object implements the JobScheduleDto interface.
 */
export function instanceOfJobScheduleDto(value?: unknown): value is JobScheduleDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(JobScheduleDtoTypeEnum)[0];
}

export function JobScheduleDtoFromJSON(json: any): JobScheduleDto {
    return JobScheduleDtoFromJSONTyped(json, false);
}

export function JobScheduleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobScheduleDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'periodStart': json['periodStart'],
        'periodEnd': json['periodEnd'],
        'executionStart': json['executionStart'],
        'executionEnd': json['executionEnd'],
        'executionAllDay': !exists(json, 'executionAllDay') ? undefined : json['executionAllDay'],
        'frequency': JobScheduleDtoFrequencyFromJSON(json['frequency']),
        'interval': !exists(json, 'interval') ? undefined : json['interval'],
        'weekdays': !exists(json, 'weekdays') ? undefined : (json['weekdays'] === null ? null : (json['weekdays'] as Array<any>).map(DayOfWeekFromJSON)),
        'timeZone': !exists(json, 'timeZone') ? undefined : json['timeZone'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function JobScheduleDtoToJSON(value?: JobScheduleDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'periodStart': value.periodStart,
        'periodEnd': value.periodEnd,
        'executionStart': value.executionStart,
        'executionEnd': value.executionEnd,
        'executionAllDay': value.executionAllDay,
        'frequency': JobScheduleDtoFrequencyToJSON(value.frequency),
        'interval': value.interval,
        'weekdays': value.weekdays === undefined ? undefined : (value.weekdays === null ? null : (value.weekdays as Array<any>).map(DayOfWeekToJSON)),
        'timeZone': value.timeZone,
        '$type': value.$type,
    });
}

